import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { toast } from 'sonner';

/** STEP 2-P7-H · Location list + create + deactivate UI (REUSE P7-G API). */
export default function OperatorLocations({ warehouseId, canAdmin }) {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ code: '', barcode: '', location_type: 'STORAGE', label: '' });

  const load = async () => {
    if (!warehouseId) return;
    try {
      const r = await api.get('/operator/warehouse-locations',
                               { params: { warehouse_id: warehouseId } });
      setRows(r.data.items || []);
    } catch (e) {
      toast.error(e?.response?.data?.detail || '조회 실패');
    }
  };
  useEffect(() => { load(); /* eslint-disable-line */ }, [warehouseId]);

  const create = async () => {
    if (!form.code) return toast.error('code 를 입력해주세요.');
    try {
      await api.post('/operator/warehouse-locations',
                     { ...form, warehouse_id: warehouseId });
      toast.success('Location 생성');
      setForm({ code: '', barcode: '', location_type: 'STORAGE', label: '' });
      load();
    } catch (e) {
      const s = e?.response?.status;
      if (s === 403) toast.error('이 작업을 처리할 권한이 없습니다.');
      else if (s === 409) toast.error('동일 창고에 같은 code/barcode 가 이미 존재합니다.');
      else toast.error(e?.response?.data?.detail || '생성 실패');
    }
  };

  const deactivate = async (loc) => {
    try {
      await api.patch(`/operator/warehouse-locations/${loc.location_id}`,
                       { is_active: !loc.is_active });
      toast.success(loc.is_active ? '비활성화 완료' : '활성화 완료');
      load();
    } catch (e) {
      const s = e?.response?.status;
      if (s === 409) toast.error(e?.response?.data?.detail || '재고가 남아있어 비활성화할 수 없습니다.');
      else if (s === 403) toast.error('이 작업을 처리할 권한이 없습니다.');
      else toast.error(e?.response?.data?.detail || '변경 실패');
    }
  };

  return (
    <div data-testid="operator-locations">
      <h1 className="text-lg font-semibold mb-3">로케이션</h1>
      {canAdmin && (
        <div className="bg-white border border-black/10 rounded-md p-3 mb-3 max-w-xl"
              data-testid="location-create-form">
          <div className="grid grid-cols-2 gap-2 text-sm">
            <input value={form.code}   onChange={(e) => setForm({ ...form, code: e.target.value })}
                    placeholder="code (예: A-01-01)" className="border rounded px-2 py-1"
                    data-testid="location-form-code" />
            <input value={form.barcode} onChange={(e) => setForm({ ...form, barcode: e.target.value })}
                    placeholder="barcode (선택)" className="border rounded px-2 py-1"
                    data-testid="location-form-barcode" />
            <select value={form.location_type}
                     onChange={(e) => setForm({ ...form, location_type: e.target.value })}
                     data-testid="location-form-type"
                     className="border rounded px-2 py-1">
              <option value="STORAGE">STORAGE</option>
              <option value="RECEIVING">RECEIVING</option>
            </select>
            <input value={form.label}  onChange={(e) => setForm({ ...form, label: e.target.value })}
                    placeholder="label (선택)" className="border rounded px-2 py-1"
                    data-testid="location-form-label" />
          </div>
          <button onClick={create} data-testid="location-create-submit"
                   className="mt-2 px-3 py-2 bg-[#FF3B30] text-white rounded text-sm">
            Location 생성
          </button>
        </div>
      )}
      <div className="bg-white border border-black/10 rounded-md divide-y">
        {rows.length === 0 && (
          <div className="p-4 text-sm text-neutral-500" data-testid="operator-locations-empty">
            등록된 Location 이 없습니다.
          </div>
        )}
        {rows.map((l) => (
          <div key={l.location_id} className="p-3 flex items-center gap-3"
                data-testid={`location-row-${l.location_id}`}>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium">{l.code}</div>
              <div className="text-xs text-neutral-500">
                {l.location_type}
                {l.barcode ? ` · barcode ${l.barcode}` : ''}
                {l.label ? ` · ${l.label}` : ''}
              </div>
            </div>
            <span className={`text-xs px-2 py-1 rounded ${
              l.is_active ? 'bg-emerald-50 text-emerald-700' : 'bg-neutral-100 text-neutral-500'
            }`} data-testid={`location-status-${l.location_id}`}>
              {l.is_active ? 'Active' : 'Inactive'}
            </span>
            {canAdmin && (
              <button onClick={() => deactivate(l)}
                       className="text-xs px-2 py-1 border rounded"
                       data-testid={`location-toggle-${l.location_id}`}>
                {l.is_active ? '비활성' : '활성'}
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
